import '@css/main.scss'
import '@js/bootstrap'

import '@js/utils/helpers'
import { Header } from '@js/components/Header'
import { Slider } from '@js/components/Slider'
import { Archive } from '@js/components/Archive'
import { Animation } from '@js/utils/Animation'
import { EasterEgg } from '@js/components/EasterEgg'
import { Loader } from '@js/utils/Loader'
import gsap from 'gsap'

window.onload = () => {

  // if (!localStorage.getItem('loader')) {
  //   localStorage.setItem('loader', 'true')
  //   new Loader()
  // } else {
  //   document.getElementById('loader').style.display = 'none'
  //   gsap.to('#app', {
  //     autoAlpha: 1
  //   })
  //   Animation.registerAnimations()
  // }

  document.getElementById('loader').style.display = 'none'
  gsap.to('#app', {
    autoAlpha: 1
  })
  Animation.registerAnimations()

  new EasterEgg()
  new Header()
  new Archive()
  new Slider()

}
